import React from 'react';
import styled from '@emotion/styled';
import HandOffLink from '../../../utils/urls/HandOffLink';
import Instagram from '../../../assets/svg/Instagram';
import Facebook from '../../../assets/svg/Facebook';
import Twitter from '../../../assets/svg/Twitter';

const SocialIcons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 6.5rem;
  height: 16px;
`;

export default () => (
  <SocialIcons>
    <HandOffLink
      identifier="paperless-post-facebook-page"
      href="http://facebook.com/pages/Paperless-Post/80813793793"
    >
      <Facebook height="1rem" width="1rem" />
    </HandOffLink>
    <HandOffLink
      identifier="paperless-post-twitter-feed"
      href="http://twitter.com/paperlesspost"
    >
      <Twitter />
    </HandOffLink>
    <HandOffLink
      identifier="paperless-post-instagram-feed"
      href="http://instagram.com/paperlesspost"
    >
      <Instagram />
    </HandOffLink>
  </SocialIcons>
);
